import axios from 'axios';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import constant from '../../utils/Constant';
import config from '../../config/config';
import Loader from '../partials/Loader';

const {
    EMPTY_STRING: emptyString,
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    STATUS_200,
    STATUS_401,
    LOGOUT,
    CHANGE_PASSWORD_END_POINT
} = constant;

const Password = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(falseValue);
    const [disable, setDisable] = useState(falseValue);
    const [formData, setFormData] = useState({
        old_password: emptyString,
        new_password: emptyString,
        confirm_password: emptyString,
    });

    // * get token from local storage
    const token = localStorage.getItem('vendor_super_token');

    // * execute change password
    const executeChangePasswordApi = async () => {

        //* old password validation
        if (!formData.old_password) {
            toast.error('Old password is required!');
            return;
        }

        //* new password validation
        if (!formData.new_password) {
            toast.error('New password is required!');
            return;
        }

        //* confirm password validation
        if (!formData.confirm_password) {
            toast.error('Confirm password is required!');
            return;
        }

        //* match validation
        if (formData.new_password !== formData.confirm_password) {
            toast.error('Password not match!');
            return;
        }

        setLoading(trueValue);
        setDisable(trueValue);

        const data = {
            current_password: formData.old_password,
            new_password: formData.new_password,
            new_password_confirmation: formData.confirm_password
        }

        try {
            const apiUrl = config.appBaseUrl + CHANGE_PASSWORD_END_POINT;

            //* post request
            const response = await axios.post(apiUrl, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            //* response success
            const result = response.data;
            if (result.code === STATUS_200 && result.status) {
                toast.success(result.message);
                setFormData({
                    old_password: emptyString,
                    new_password: emptyString,
                    confirm_password: emptyString,
                })
            } else {
                toast.error(result.message);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);

            // * if user is unauthorized
            if (error.response.data.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setDisable(falseValue);
            setLoading(falseValue);
        }
    };

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex  align-items-start align-items-sm-center justify-content-between gap-2">
                                <h4 className="mb-0">Update Password</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Update Password</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6">
                            <div className="card">
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="old_passsword" className="form-label">
                                                        Old Password
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id='old_passsword'
                                                        className="form-control m-0"
                                                        name="old_password"
                                                        placeholder="Enter old password"
                                                        value={formData.old_password}
                                                        onChange={(e) => setFormData({ ...formData, old_password: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="new_passsword" className="form-label">
                                                        New Password
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id='new_passsword'
                                                        className="form-control m-0"
                                                        name="password"
                                                        placeholder="Enter new password"
                                                        value={formData.new_password}
                                                        onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="confirm_passsword" className="form-label">
                                                        Confirm Password
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id='confirm_passsword'
                                                        className="form-control m-0"
                                                        name="password"
                                                        placeholder="Enter confirm password"
                                                        value={formData.confirm_password}
                                                        onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center  justify-content-end">
                                            <button
                                                className="btn btn-dark text-white"
                                                type="button"
                                                onClick={executeChangePasswordApi}
                                                disabled={disable}
                                            >
                                                {!loading ? 'Update' : <Loader />}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Password;